const getTwoDigitNumber = (num) => {
  if (num < 10) {
    return `0${num}`;
  }
  return num;
};

const getISOString = (date) => {
  // 'YYYY-MM-DDTHH:mm:ss'
  const dateModel = new Date(date);
  const year = dateModel.getFullYear();
  let month = getTwoDigitNumber(dateModel.getMonth() + 1);
  let day = getTwoDigitNumber(dateModel.getDate());
  const hours = getTwoDigitNumber(dateModel.getHours());
  const minutes = getTwoDigitNumber(dateModel.getMinutes());
  return `${year}-${month}-${day}T${hours}:${minutes}:00`;
};

export const formatDateQuery = (startDate, endDate, location) => {
  const startISO = getISOString(startDate);
  const endISO = getISOString(endDate);
  const { latitude, longitude } = location;
  return `&availability_interval=${latitude},${longitude},${startISO},${endISO}`;
};
